export const VALIDATION_ERROR =
    'Unable to connect to Workable using the configuration provided. Please check that the subdomain and partner token are correct.';
